<template>
  <div am-instuction-cond-modal>
    <div class="_background:black" am-cond-modal-bg @click="close()" />
    <i-card am-cond-modal-body>
      <template #header>
        <div class="_display:flex _justify-content:space-between _align-items:center">
          <p class="_margin:1/4">{{modalCond.data.step_name}}</p>
          <i-icon class="_float:right" am-icon-close name="ink-times" @click="close()" />
        </div>
      </template>
      <div :class="`_margin-bottom:1/2 _display:flex ${isShowWarning ? '_justify-content:space-between _align-items:center' : '_justify-content:flex-end'}`">
        <p v-if="isShowWarning" class="_text:danger">You have unsaved changes</p>
        <div>
          <i-button
            v-if="isShowWarning"
            style="width: 100px;"
            class="_margin-right:1/2"
            size="sm"
            @click="deleteConditions"
          >
            Discard
          </i-button>
          <i-button
            color="primary"
            style="width: 100px;"
            size="sm"
            @click="saveConditions"
            :disabled="isParamError"
          >
            Save
          </i-button>
        </div>
      </div>
      <i-card class="_margin-bottom:1">
        <p class="_font-size:md _text-transform:uppercase">Conditions</p>
        <div
          v-for="(and, index) in conditions"
          :key="index"
          class="_display:flex _flex-direction:column"
        >
          <div v-if="index > 0" class="_margin-top:1/2 _margin-bottom:1/2">
            or
          </div>
          <div class="_display:flex _flex-wrap:wrap" am-cond>
            <div
              v-for="(param, i) in and"
              :key="i"
              class="_display:flex _align-items:center _margin-bottom:2 _margin-top:1"
            >
              <div class="_display:flex _position:relative" am-params-inputs>
                <input-condition
                  v-model="param.key"
                  placeholder="key"
                  @change="(event)=>watchKey(event, index, i)"
                  :error="paramKeyError[i + '-' + index]"
                  :errorMessage="dropValues.join(', ')"
                />
                <p class="_margin-left:1"></p>
                <input-condition
                  v-model="param.value"
                  @keypress="watchValue"
                  placeholder="value"
                />
                <formulaTooltip :number="param.key" :value="param.value" />
              </div>
              <svg
                viewBox="0 0 24 24"
                am-icon
                style="fill: var(----color);"
                class="_margin-left:1/2"
                @click="delParam(index, i)"
              >
                <use xlink:href="@/assets/icons.svg#minus-bg" x="0" y="0" width="24" height="24"></use>
              </svg>
              <i-button
                class="_margin-left:1"
                v-if="and.length - 1 === i"
                @click="and.push({ key: '', value: '' })"
              >
                AND
              </i-button>
              <div v-else class="_margin-left:1 _margin-right:1">and</div>
              <svg
                viewBox="0 0 24 24"
                am-icon
                style="fill: var(----color);"
                class="_margin-left:1/2"
                @click="delCondition(index)"
                v-if="and.length - 1 === i"
              >
                <use xlink:href="@/assets/icons.svg#minus" x="0" y="0" width="24" height="24"></use>
              </svg>
            </div>
          </div>
          <i-button
            class="_margin-top:1"
            v-if="conditions.length - 1 === index"
            @click="conditions.push([{ key: '', value: '' }])"
          >
            OR
          </i-button>
        </div>
      </i-card>
    </i-card>
  </div>
</template>

<script setup>
import { useStore } from 'vuex'
import { computed, onMounted, ref, onUnmounted } from 'vue'
import InputCondition from './inputCondition.vue'
import formulaTooltip from '../formula/formulaTooltip.vue'

const store = useStore()

const modalCond = computed(() => {
  return store.state.instructions.modalCond
})
const isShowWarning = ref(false)
const deleteConditions = () => {
  modalCond.value.isShow = false
}
const close = (event) => {
  const condNew = []
  conditions.value.forEach(cond => {
    const obj = {}
    cond.forEach(el => {
      if (el.key && el.value) {
        if (!obj[el.key]) obj[el.key] = []
        if (el.value.includes(',')) {
          el.value.split(',').forEach(v => {
            if (v.trim()) {
              if (!obj[el.key].includes(Number(v.trim()))) obj[el.key].push(Number(v.trim()))
            }
          })
        } else {
          if (!obj[el.key].includes(Number(el.value.trim()))) obj[el.key].push(Number(el.value.trim()))
        }
      }
    })
    if (Object.keys(obj).length > 0) {
      condNew.push(obj)
    }
  })
  if (JSON.stringify(condNew) !== JSON.stringify(modalCond.value.data.cond)) {
    if (
      modalCond.value.data.cond.length === 1 &&
      Array.isArray(modalCond.value.data.cond[0]) &&
      modalCond.value.data.cond[0].length === 0
    ) {
      isShowWarning.value = false
      modalCond.value.isShow = false
    }
    isShowWarning.value = true
  } else {
    isShowWarning.value = false
    modalCond.value.isShow = false
  }
}
const conditions = ref([])
onMounted(() => {
  store.commit('ui/closeModal', close)
  modalCond.value.data.cond.forEach((condition, index) => {
    conditions.value.push([])
    for (const key in condition) {
      const value = condition[key] instanceof Array ? condition[key].join() : condition[key]
      conditions.value[index].push({ key: key, value: value })
    }
  })
  if (
    modalCond.value.data.cond.length === 0 ||
    (modalCond.value.data.cond.length === 1 && Array.isArray(modalCond.value.data.cond[0]))
  ) {
    conditions.value = [[{
      value: '',
      key: ''
    }]]
  }
})
onUnmounted(() => {
  store.commit('ui/closeModal', null)
})
const isParamError = computed(() => {
  let error = false
  if (Object.keys(paramKeyError.value).length > 0) {
    Object.keys(paramKeyError.value).forEach(el => {
      if (paramKeyError.value[el] === true) error = true
    })
  }
  return error
})
const paramKeyError = ref({})
const dropValues = computed(() => {
  return store.getters['formula/dropValues'].slice(1)
})
const watchKey = (event, index, i) => {
  const data = event.target.value.toLowerCase()
  const regex = new RegExp(`^[0-9]{1,}$|^${dropValues.value.join('$|^')}$`, 'g')
  const found = regex.test(data)
  if (!found) {
    paramKeyError.value[i + '-' + index] = true
  } else {
    paramKeyError.value[i + '-' + index] = false
  }
}
const watchValue = (event) => {
  const regex = /^[0-9 ,]+$/
  const key = String.fromCharCode(!event.charCode ? event.which : event.charCode)
  if (!regex.test(key)) {
    event.preventDefault()
    return false
  }
}
const delCondition = (index) => {
  conditions.value.splice(index, 1)
  if (conditions.value.length === 0) {
    conditions.value[0] = [{
      value: '',
      key: ''
    }]
  }
}
const delParam = (index, i) => {
  conditions.value[index].splice(i, 1)
  if (conditions.value[index].length === 0) {
    delCondition(index)
  }
}
const saveConditions = () => {
  if (isParamError.value) return
  isShowWarning.value = false
  modalCond.value.data.cond = []
  conditions.value.forEach(cond => {
    const obj = {}
    cond.forEach(el => {
      if (el.key && el.value) {
        if (!obj[el.key]) obj[el.key] = []
        if (el.value.includes(',')) {
          el.value.split(',').forEach(v => {
            if (v.trim()) {
              if (!obj[el.key].includes(Number(v.trim()))) obj[el.key].push(Number(v.trim()))
            }
          })
        } else {
          if (!obj[el.key].includes(Number(el.value.trim()))) obj[el.key].push(Number(el.value.trim()))
        }
      }
    })
    modalCond.value.data.cond.push(obj)
  })
  save()
}
const save = async () => {
  const updated = await store.dispatch('instructions/updateInstruction', { value: { cond: modalCond.value.data.cond }, id: modalCond.value.data.id })
  if (updated) {
    modalCond.value.isShow = false
  }
}
</script>

<style lang="scss">
[am-instuction-cond-modal] {
  top: 0;
  z-index: 1000;
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  [am-params-inputs] {
    position: relative;
    &:hover {
      [am-toltip] {
        top: 45px;
        display: block;
      }
    }
  }

  [am-cond-modal-bg] {
    opacity: 0.4;
    height: 100%;
    width: 100%;
  }
  [am-cond-modal-body] > .card-body {
    overflow-y: scroll;
  }
  [am-cond-modal-body] {
    position: absolute;
    max-height: 90%;
    max-width: 50%;
    width: 50%;
    overflow-x: hidden;
  }
  [am-icon-close] {
    cursor: pointer;
    width: 0.5rem;
  }
}
</style>
